import React from "react"
import { PageContent, CustomBreadcrumb } from "components/Common";
import TotalStatistic from "./TotalStatistic";
import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types"

const RESOURCE = ModuleIds.User;

const UsersContainer = ({ t }) => {
    const titleTag = t("Thống kê dữ liệu tổng")
    return (
        <PageContent title={t(titleTag)}>
            {/* Page Title */}
            < CustomBreadcrumb
                breadcrumbItem={titleTag}
                resource={RESOURCE}
                icon={<i className="bx bx-file" />}
            />
            {/* Page Body */}
            <TotalStatistic />
        </PageContent >
    )
}

UsersContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["sitePage"])(UsersContainer)